'use strict';

var cov_1jh6ud8blb = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/interactionTypesList/interactionTypesList.js',
        hash = 'f81259434979d5aacfd003d9c3f04007c255f25b',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/interactionTypesList/interactionTypesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1jh6ud8blb.s[0]++;
angular.module('app').component('interactionTypesList', {
    templateUrl: 'app/components/interactionTypesList/interactionTypesList.html',
    bindings: {
        interactionTypes: '<'
    }
});